var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tab-container card" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c("ul", { staticClass: "head" }, [
          _vm.isForVendor()
            ? _c(
                "li",
                {
                  staticClass: "head-item",
                  class: { current: _vm.isActiveFlag(1) },
                  on: {
                    click: function($event) {
                      _vm.setActiveFlag(1)
                    }
                  }
                },
                [_vm._v("供应商")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isForServicer()
            ? _c(
                "li",
                {
                  staticClass: "head-item",
                  class: { current: _vm.isActiveFlag(2) },
                  on: {
                    click: function($event) {
                      _vm.setActiveFlag(2)
                    }
                  }
                },
                [_vm._v("服务商")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isForVendor()
            ? _c(
                "li",
                {
                  staticClass: "head-item",
                  class: { current: _vm.isActiveFlag(3) },
                  on: {
                    click: function($event) {
                      _vm.setActiveFlag(3)
                    }
                  }
                },
                [_vm._v("我的供应商")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isForServicer()
            ? _c(
                "li",
                {
                  staticClass: "head-item",
                  class: { current: _vm.isActiveFlag(4) },
                  on: {
                    click: function($event) {
                      _vm.setActiveFlag(4)
                    }
                  }
                },
                [_vm._v("我的服务商")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.isForVendor()
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isActiveFlag(1),
                  expression: "isActiveFlag(1)"
                }
              ],
              staticClass: "tabs-content"
            },
            [
              _c("swb-vendor-for-select", {
                ref: "swb_vendor_for_select",
                attrs: {
                  ebChannel: _vm.ebChannel,
                  includeHidden: _vm.includeHidden,
                  multiSelect: _vm.multiSelect,
                  initCheckedItem: _vm.initCheckedItem,
                  initCheckedItems: _vm.initCheckedItems
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isForServicer()
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isActiveFlag(2),
                  expression: "isActiveFlag(2)"
                }
              ],
              staticClass: "tabs-content"
            },
            [
              _c("swb-servicer-for-select", {
                ref: "swb_servicer_for_select",
                attrs: {
                  ebChannel: _vm.ebChannel,
                  multiSelect: _vm.multiSelect,
                  initCheckedItem: _vm.initCheckedItem,
                  initCheckedItems: _vm.initCheckedItems
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isForVendor()
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isActiveFlag(3),
                  expression: "isActiveFlag(3)"
                }
              ],
              staticClass: "tabs-content"
            },
            [
              _c("swb-merchant-biz-rel-with-me-list", {
                ref: "swb_merchant_biz_rel_list_v",
                attrs: {
                  ebChannel: _vm.ebChannel,
                  multiSelect: _vm.multiSelect,
                  initCheckedItem: _vm.initCheckedItem,
                  initCheckedItems: _vm.initCheckedItems,
                  type: _vm.type
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isForServicer()
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isActiveFlag(4),
                  expression: "isActiveFlag(4)"
                }
              ],
              staticClass: "tabs-content"
            },
            [
              _c("swb-merchant-biz-rel-with-me-list", {
                ref: "swb_merchant_biz_rel_list_s",
                attrs: {
                  ebChannel: _vm.ebChannel,
                  multiSelect: _vm.multiSelect,
                  initCheckedItem: _vm.initCheckedItem,
                  initCheckedItems: _vm.initCheckedItems,
                  type: _vm.type
                }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bbd4c7ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbd4c7ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/OrientationBidList.vue
// module id = 2098
// module chunks = 0